import React from "react";
import { Tag, Typography } from "antd";

import { ago } from "@components/Date";
import { type PersonalAccessToken } from "@api/types";

import TableRowActions from "../TableRowActions";

const LABEL_NAME = "Name";
const LABEL_STATUS = "Status";
// const LABEL_AUDIENCES = "Audiences";
const LABEL_EXPIRES_AT = "Expires";
const LABEL_LAST_USED_AT = "Last Used";
// const LABEL_USAGE_COUNT = "Uses";
// const LABEL_CREATED_AT = "Created";
// const LABEL_ALL_AUDIENCES = "All";
const LABEL_EMPTY = "-";
const LABEL_EXPIRED = "Expired";

const STATUS_ACTIVE = "ACTIVE";

type Props = {
  onRevoked: (revokedToken: PersonalAccessToken) => void;
};

const useColumnsConfig = ({ onRevoked }: Props) => {
  const nameColumnProps = {
    key: "name",
    title: LABEL_NAME,
    render: (name: string) => (
      <Typography.Text strong>{name}</Typography.Text>
    ),
    isSearchable: true,
  };

  const statusColumnProps = {
    key: "status",
    title: LABEL_STATUS,
    render: (status: string, { expiresAt }: PersonalAccessToken) => {
      const isRevoked = status !== STATUS_ACTIVE;

      if (isRevoked) {
        return <Tag color="red">{status}</Tag>;
      }

      const isExpired = new Date(expiresAt).getTime() < Date.now();

      if (isExpired) {
        return <Tag color="orange">{LABEL_EXPIRED}</Tag>;
      }

      return <Tag color="green">{status}</Tag>;
    },
  };

  // const audiencesColumnProps = {
  //   key: "audiences",
  //   title: LABEL_AUDIENCES,
  //   render: (audiences?: string[]) => {
  //     const hasAudiences = !!audiences && audiences.length > 0;

  //     if (!hasAudiences) {
  //       return (
  //         <Typography.Text type="secondary">
  //           {LABEL_ALL_AUDIENCES}
  //         </Typography.Text>
  //       );
  //     }

  //     return audiences.map(audience => <Tag key={audience}>{audience}</Tag>);
  //   },
  // };

  const expiresAtColumnProps = {
    key: "expiresAt",
    title: LABEL_EXPIRES_AT,
    render: (value: string) => ago(value, true),
  };

  const lastUsedAtColumnProps = {
    key: "lastUsedAt",
    title: LABEL_LAST_USED_AT,
    render: (value?: string) => {
      const hasValue = !!value;

      if (!hasValue) {
        return LABEL_EMPTY;
      }

      return ago(value, true);
    },
  };

  // const usageCountColumnProps = {
  //   key: "usageCount",
  //   title: LABEL_USAGE_COUNT,
  // };

  // const createdAtColumnProps = {
  //   key: "createdAt",
  //   title: LABEL_CREATED_AT,
  //   render: (value: string) => ago(value, true),
  // };

  const actionsColumnProps = {
    key: "actions",
    title: false,
    width: 48,
    render: (_: unknown, personalAccessToken: PersonalAccessToken) => (
      <TableRowActions
        personalAccessToken={personalAccessToken}
        onRevoked={onRevoked}
      />
    ),
  };

  return [
    { ...nameColumnProps },
    // { ...audiencesColumnProps },
    // { ...usageCountColumnProps },
    { ...lastUsedAtColumnProps },
    // { ...createdAtColumnProps },
    { ...expiresAtColumnProps },
    { ...statusColumnProps },
    { ...actionsColumnProps },
  ];
};

export default useColumnsConfig;
